const USA_COUNTRY_ID = 233;

export interface AddressRecord {
  address?: string | null;
  address2?: string | null;
  city?: string | null;
  countryId?: number | null;
  stateName?: string | null;
  state?: { displayName?: string | null } | null;
  zip?: string | null;
  country?: { displayName?: string | null } | null;
}

// Outside the USA the free-text state name wins; inside it the picked state does.
export const formatAddress = (item?: AddressRecord | null): string => {
  if (!item) {
    return '';
  }
  const stateName = item.countryId !== USA_COUNTRY_ID
    ? item.stateName || ''
    : item.state?.displayName || '';
  return [
    item.address || '',
    item.address2 || '',
    item.city || '',
    stateName || item.state?.displayName || '',
    item.zip || '',
    item.country?.displayName || '',
  ]
    .filter((value) => value.trim().length > 0)
    .join(', ');
};
